module.exports = __webpack_public_path__ + "static/media/Brand.7aa66770.png";